import Vue from 'vue';

/**
 *  Wrapper function for the respective auth plugin's getTokenSilently method
 */
export const getTokenSilently = () => {
    return Vue.prototype?.$auth?.getTokenSilently()
}